import { render, staticRenderFns } from "./WellSelectionFilters.vue?vue&type=template&id=0af7c542"
import script from "./WellSelectionFilters.vue?vue&type=script&lang=js"
export * from "./WellSelectionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports